import React from "react";
import clsx from "clsx";
import AppLoader from "@/components/AppLoader";
import AppBox from "@/components/AppBox";
import { FORM_ELEMENT_HEIGHT } from "@/constants/styles";

interface AppButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outlined" | "text" | "error" | "dropdown";
  size?: "small" | "medium" | "large";
  isLoading?: boolean;
  disabled?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({
  children,
  onClick,
  variant = "secondary",
  size = "medium",
  isLoading = false,
  className = "",
  disabled = false,
  ...props
}) => {
  const variantClasses = {
    primary: "bg-primary text-white hover:bg-primary-hover",
    secondary: "bg-secondary text-white hover:bg-secondary-hover",
    outlined: "border border-secondary text-secondary hover:bg-secondary-hover hover:text-white",
    text: "text-primary hover:bg-primary hover:text-white",
    error: "bg-error text-white hover:bg-error-hover",
    dropdown: "border border-gray-300 text-gray-900 hover:bg-gray-50 shadow-sm"
  };

  const sizeClasses = {
    small: "px-3 text-sm",
    medium: "px-4 text-base",
    large: "px-5 text-lg",
  };

  return (
    <button
      onClick={onClick}
      className={clsx(
        "relative inline-flex w-full items-center justify-center rounded transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
        FORM_ELEMENT_HEIGHT,
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      disabled={disabled}
      {...props}
    >
      {/* Loader */}
      {isLoading && (
        <AppBox
          fullWidth
          fullHeight
          justify="center"
          align="center"
          className="absolute top-0 left-0 bg-opacity-50"
        >
          <AppLoader
            color={variant === "outlined" ? "secondary" : "white"}
            size={20}
          />
        </AppBox>
      )}

      {/* Button Content */}
      
      {!isLoading ? children : null}
    </button>
  );
};

export default AppButton;